//import AddToCartButton from '../../util/addToCartButton'

export default function Item(props) {

		//ELSE
			//let affiliateGoToPageHref="https://linksynergy.walmart.com/deeplink?id=mZBF1JmBhNo&mid=2149&u1=PM&murl=http%3A%2F%2Fwww.walmart.com%2Fip%2F" + props.current.itemId

			let href

			if (props.website && props.website === 'walmartGrocery'){
				href = 'https://grocery.walmart.com/ip/item/' + props.currentProduct.itemId
			} else {
				href = 'https://www.walmart.com/ip/' + props.currentProduct.itemId
			}

			let {currentProduct, carouselItemsRows, itemcellTemplateHeights} = props

			//console.log(current)
			//for each item. do the same function you did to build first column
			let viewRebate = (event) => {

					let productIdClicked = event && event.target && event.target.value ? event.target.value : null

					if (typeof window !== "undefined") {

							let {urlParameters} = props
							let productId = urlParameters && urlParameters.productId ? urlParameters.productId  : null
							let richId = urlParameters && urlParameters.richId ? urlParameters.richId : null
							let campaignId = urlParameters && urlParameters.campaignId ? urlParameters.campaignId  : null
							let retailer = urlParameters && urlParameters.retailer  ? urlParameters.retailer : 'walmart'
							let website = urlParameters && urlParameters.website  ? urlParameters.website : 'walmart'
							let medium = urlParameters && urlParameters.medium  ? urlParameters.medium : 'ec'
							let source = urlParameters && urlParameters.source  ? urlParameters.source : 'walmart'
							let brand = urlParameters && urlParameters.brand  ? urlParameters.brand : null
							let cat = urlParameters && urlParameters.cat  ? urlParameters.cat : null


							window.dataLayer = window.dataLayer || [];
							window.dataLayer.push({
								"event" : "cc.clickedViewRebate",
								productIdClicked,
								productId,
								richId,
								campaignId,
								retailer,
								website,
								medium,
								source,
								brand,
								cat
							})
					} else {
							//window.not available
							//console.log('window na')
					}
			}

			let column = carouselItemsRows.map( (currentRow, index) => {

					let rowBackgroundColor = index % 2 ? '#F5FBFF' : '#DDECF3'
					//if itemcellTemplateHeights doesn't exist for curret item template then default to 62
					let itemCellHeight = itemcellTemplateHeights[currentRow.id] ? itemcellTemplateHeights[currentRow.id] : 62

					if (currentRow.id === 'fullSizeImage'){

						return(
							<div style={{ height: itemCellHeight + 'px', padding: '10px', backgroundColor: '#fff' , overflow: 'hidden', alignItems:'center', justifyContent:'center', display: 'flex', flexDirection: 'column'}}>

									<div style={{height: '150px', paddingBottom: '5px'}}>
										<img src={currentProduct[currentRow.id]} aria-label="product image" style={{ height: '100%', backgroundColor: '#fff'}} />
									</div>

									<div style={{height: '20px', display: 'flex', justifyContent: 'center'}}>
									<a data-contenttype="ct" data-btnlocation="cell" data-itemid={currentProduct.itemId}
										alt='Go To Page' href={href} target='_blank' rel='noreferrer noopener' aria-label="go to item page"
										style={{ textDecoration: 'underline'}}
									>Go To Page ›</a>
									</div>

							</div>
						)
					} else if ( currentRow.id === 'salePrice'){
						return(
							<div style={{ height: itemCellHeight + 'px', padding: '15px', backgroundColor: rowBackgroundColor , overflow: 'hidden',  display: 'flex', alignItems:'center', justifyContent:'center'}}>
								<b aria-label="current price" style={{fontSize: '15px'}}>${ currentProduct[currentRow.id] }</b>
							</div>
						)
					} else if ( currentRow.id === 'rebate' ){
						return(
							<div style={{ height: itemCellHeight + 'px', padding: '15px', backgroundColor: rowBackgroundColor , overflow: 'hidden',  display: 'flex', alignItems:'center', justifyContent:'center'}}>
								<b aria-label="current rebate" style={{fontSize: '25px'}}>
								{ currentProduct && currentProduct[currentRow.id]  ?
									<span>${ currentProduct[currentRow.id] }</span>
									:
									<span>-</span>
								}
								</b>
							</div>
						)
					} else if ( currentRow.id === 'rebateLink' ){

						if ( currentProduct[currentRow.id] ){
						return(
							<div style={{ height: itemCellHeight + 'px', padding: '15px', backgroundColor: rowBackgroundColor , overflow: 'hidden', display: 'flex', justifyContent:'center'}}>
								<a href={currentProduct.rebateLink} style={{textDecoration: 'underline'}} target="_blank" rel="noopener noreferrer" >
									<button className='rebateButton blue-button btn' value={currentProduct.productId} onClick={viewRebate} aria-label="view rebate">
										View Rebate
									</button>
								</a>
							</div>
						)
						}
					} else if ( currentRow.dot === true ){
						let showDot = !!currentProduct[currentRow.id]
						return(
							<div style={{ height: itemCellHeight + 'px', padding: '15px', backgroundColor: rowBackgroundColor , overflow: 'hidden',  display: 'flex', alignItems:'center', justifyContent:'center'}}>
								{ showDot &&
									<div style={{height: '7px', width:'7px', borderRadius: '50%', backgroundColor: '#000'}} />
								}
							</div>
						)
					}

					return(
						<div style={{ height: itemCellHeight + 'px', padding: '15px', backgroundColor: rowBackgroundColor , overflow: 'hidden', display: 'flex', alignItems:'center', justifyContent:'center'}}>
							<span aria-label={currentProduct[currentRow.id]}>{ currentProduct[currentRow.id] }</span>
						</div>
					)
			})

			return (
				<div style={{display: 'flex', flex: 1, flexDirection:'column'}}>
					{column}
				</div>
			);

}



// WEBPACK FOOTER //
// ./components/contentTypes/compareCarousel/item.js